const CatchMessage = (err) => {
  if (err.response?.data?.status == 401) {
    localStorage.removeItem("userData");
    location.reload();
  }
  console.log(err);
};

export default CatchMessage;
